import React from "react";

export default function SurfaceCard({
  as: Component = "section",
  children,
  className = "",
  ...props
}) {
  return (
    <Component
      className={["surface-card", className].filter(Boolean).join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
